import { httpsCallable } from "firebase/functions";
import { auth, functions } from "./firebase";

export function recordActivity(action, resource = {}, code = "") {
  if (!auth?.currentUser) return Promise.resolve(false);
  const eventId = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return Promise.resolve().then(() => httpsCallable(functions, "auditActivity", { timeout: 5000 })({ action, resource, code, eventId }))
    .then(() => true).catch(() => false);
}

// Add identity to same-origin legacy endpoints without putting tokens in URLs.
export async function auditFetch(url, options = {}) {
  const headers = new Headers(options.headers);
  if (typeof url === "string" && url.startsWith("/") && !url.startsWith("//") && auth?.currentUser) {
    const token = await auth.currentUser.getIdToken();
    headers.set("Authorization", `Bearer ${token}`);
  }
  return fetch(url, { ...options, headers });
}
